import React, { useEffect } from 'react';
import $ from 'jquery';

const PrivacyPolicy = ({imgObject}) => {
    useEffect(()=>{
        $('[data-bg-img]').each(function() {
            $(this).css('background-image', 'url(' + $(this).data("bg-img") + ')');
        });
        $('[data-margin-top]').each(function() {
            $(this).css('margin-top', $(this).data("margin-top"));
        });
    },[]);
  return (
    <>
        <section className="inner-header divider parallax layer-overlay overlay-dark-5" data-bg-img={imgObject.bgImage}>
            <div className="container pt-70 pb-20">
                {/* <!-- Section Content --> */}
                <div className="section-content">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="title text-white">Privacy Policy</h2>
                            <ol className="breadcrumb text-left text-black mt-10">
                                <li><a href="#">Home</a></li>
                                <li className="active text-gray-silver">Privacy Policy</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="mission">
            <div className="container">
                <div className="section-title text-center">
                    <div className="row">
                        <div className="col-md-12 ">
                            <h2 className="text-uppercase line-bottom-double-line-centered mt-0"> <span className="text-theme-colored2">Privacy Policy</span></h2>
                        </div>
                    </div>
                </div>
                <div className="section-content text-content">
                    <ol type='1'>
                        <li style={{"text-align":"justify"}}><b>1. Introduction</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>United Securities Limited (“USL”, “we”, “our”, or “us”) is committed to protecting your privacy </li>
                            <li style={{"text-align":"justify"}}>This policy explains how we collect, use, and safeguard your information</li>
                            <li style={{"text-align":"justify"}}>Applies to:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Website (www.unitedsecurities.com.bd)</li>
                                <li style={{"text-align":"justify"}}>Mobile apps (e.g., USL Momentum)</li>
                                <li style={{"text-align":"justify"}}>Social media platforms (Facebook, LinkedIn, YouTube, etc.)</li>
                            </ul>
                            <li style={{"text-align":"justify"}}>By using our services, you agree to this Privacy Policy</li>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>2. Eligibility</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>You must be <b>at least 18 years old</b></li>
                            <li style={{"text-align":"justify"}}>You must have legal capacity to enter into an agreement</li>
                            <li style={{"text-align":"justify"}}>You must have at least one active account with USL</li>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>3. Information We Collect</b></li>
                        <ol type='1'>
                            <li style={{"text-align":"justify"}}><b>3.1 Personal Information</b></li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Full name, address, date of birth </li>
                                <li style={{"text-align":"justify"}}>Mobile number and email address </li>
                                <li style={{"text-align":"justify"}}>National ID or other identification details </li>
                                <li style={{"text-align":"justify"}}>Financial and account-related information </li>
                            </ul>
                            <li style={{"text-align":"justify"}}><b>3.2 Technical Information</b></li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Device details (mobile, computer, tablet) </li>
                                <li style={{"text-align":"justify"}}>IP address and browser type</li>
                                <li style={{"text-align":"justify"}}>Login data and usage activity</li>
                            </ul>
                            <li style={{"text-align":"justify"}}><b>3.3 Transaction Information</b></li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Instructions submitted through our platforms </li>
                                <li style={{"text-align":"justify"}}>Payment and transaction history</li>
                                <li style={{"text-align":"justify"}}>Account activity and preferences</li>
                            </ul>
                        </ol>                        
                        <li style={{"text-align":"justify"}}><b>4. Use of Information</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Provide and maintain our services</li>
                            <li style={{"text-align":"justify"}}>Verify identity and ensure account security</li>
                            <li style={{"text-align":"justify"}}>Process transactions and execute instructions</li>
                            <li style={{"text-align":"justify"}}>Send updates, alerts, and notifications</li>
                            <li style={{"text-align":"justify"}}>Improve system performance and user experience</li>
                            <li style={{"text-align":"justify"}}>Comply with legal and regulatory requirements</li>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>5. Account Access & Security</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Access requires:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Registered mobile number</li>
                                <li style={{"text-align":"justify"}}>Acceptance of Terms & Conditions</li>
                            </ul>
                            <li style={{"text-align":"justify"}}>You must:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Keep login credentials confidential</li>
                                <li style={{"text-align":"justify"}}>Use only devices you own or control</li>
                                <li style={{"text-align":"justify"}}>Prevent unauthorized access</li>
                                <li style={{"text-align":"justify"}}>Avoid using public or unsecured Wi-Fi networks</li>
                            </ul>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>6. User Responsibilities</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Ensure all provided information is accurate and complete </li>
                            <li style={{"text-align":"justify"}}>Carefully verify all instructions before submission </li>
                            <li style={{"text-align":"justify"}}>Do not share or expose security credentials </li>
                            <li style={{"text-align":"justify"}}>USL is not liable for losses caused by:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Wrong input (account, PIN, amount, etc.) </li>
                                <li style={{"text-align":"justify"}}>Negligence in protecting login details </li>
                            </ul>                            
                        </ul>
                        <li style={{"text-align":"justify"}}><b>7. System Availability & Updates</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Services may be unavailable due to: </li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Maintenance</li>
                                <li style={{"text-align":"justify"}}>System upgrades</li>
                            </ul>
                            <li style={{"text-align":"justify"}}>Updates may be: </li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Automatic</li>
                                <li style={{"text-align":"justify"}}>Manual</li>
                            </ul>
                            <li style={{"text-align":"justify"}}>Changes may occur without prior notice </li>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>8. Third-Party Services</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Some services depend on third-party providers </li>
                            <li style={{"text-align":"justify"}}>USL: </li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Does not control these services </li>
                                <li style={{"text-align":"justify"}}>Is not responsible for service interruptions </li>
                            </ul>
                            <li style={{"text-align":"justify"}}>Access may be limited if third-party services fail</li>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>9. Data Security</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>We implement reasonable security measures</li>
                            <li style={{"text-align":"justify"}}>However: </li>
                            <ul>
                                <li style={{"text-align":"justify"}}>No system is completely secure</li>
                                <li style={{"text-align":"justify"}}>Risk of cyber threats remains</li>
                            </ul>
                            <li style={{"text-align":"justify"}}>Use of service is at your own risk</li>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>10. Fees and Charges</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Users must pay applicable service fees</li>
                            <li style={{"text-align":"justify"}}>USL may:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Modify fees at its discretion</li>
                                <li style={{"text-align":"justify"}}>Update charges without prior notice</li>
                            </ul>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>11. Authorization of Instructions</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Use of login/security credentials means:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>You authorize USL to act on your instructions</li>
                            </ul>                            
                            <li style={{"text-align":"justify"}}>USL may:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>Process transactions </li>
                                <li style={{"text-align":"justify"}}>Debit your account accordingly </li>
                            </ul>
                        </ul>                        
                        <li style={{"text-align":"justify"}}><b>12. Limitation of Liability</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>USL is not responsible for:</li>
                            <ul>
                                <li style={{"text-align":"justify"}}>User mistakes or incorrect instructions</li>
                                <li style={{"text-align":"justify"}}>Unauthorized access due to negligence</li>
                                <li style={{"text-align":"justify"}}>Loss from stolen or compromised devices</li>                           
                                <li style={{"text-align":"justify"}}>Internet failures or cyber incidents </li>
                            </ul> 
                        </ul>                        
                        <li style={{"text-align":"justify"}}><b>13. Changes to Privacy Policy</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}>Policy may be updated periodically</li>
                            <li style={{"text-align":"justify"}}>Changes become effective upon posting</li>
                            <li style={{"text-align":"justify"}}>Continued use means acceptance of updates</li>
                        </ul>
                        <li style={{"text-align":"justify"}}><b>14. Contact Information</b></li>
                        <ul>
                            <li style={{"text-align":"justify"}}><b>United Securities Limited</b></li>
                            <li style={{"text-align":"justify"}}>📧 Email: it@unitedsecurities.com.bd</li>
                            <li style={{"text-align":"justify"}}>📍 Address: Unicentral, 11th Floor, Civil Aviation Plot, Tongi Highway, Dhaka-1229</li>
                        </ul>
                    </ol>
                </div>
            </div>
        </section>
    </>
  )
}

export default PrivacyPolicy
